export const TIPI_DOCUMENTO = {
  5: 'Scontrino',
  4: 'Fattura',
  2: 'Ricevuta fiscale',
  15: 'Concordati',
  0: 'Conto diviso',
  16: 'Fattura fine mese',
  261: 'Scontrino diviso',
  260: 'Fattura divisa',
  258: 'Ricevuta divisa',
};

export const TIPI_PAGAMENTO = {};
